(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-collection-sort]');
    if (!select) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-page')) {
    class ProductPage extends HTMLElement {
      connectedCallback() {
        const variantsJson = this.querySelector('[data-product-variants]');
        try {
          this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
        } catch (e) {
          console.error('Product variants JSON could not be parsed:', e);
          this.variants = [];
        }
        this.optionFieldsets = Array.from(this.querySelectorAll('.product__option'));

        this.querySelectorAll('[data-option-value]').forEach((button) => {
          button.addEventListener('click', () => this.selectOptionValue(button));
        });

        this.querySelectorAll('[data-thumbnail]').forEach((button) => {
          button.addEventListener('click', () => this.selectThumbnail(button));
        });

        this.querySelector('[data-qty-decrease]')?.addEventListener('click', () => this.stepQuantity(-1));
        this.querySelector('[data-qty-increase]')?.addEventListener('click', () => this.stepQuantity(1));
      }

      stepQuantity(delta) {
        const input = this.querySelector('[data-qty-input]');
        if (!input) return;
        const min = parseInt(input.min || '1', 10);
        const next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
        input.value = next;
      }

      selectOptionValue(button) {
        const fieldset = button.closest('.product__option');
        fieldset.querySelectorAll('[data-option-value]').forEach((el) => el.classList.remove('product__option-value--active'));
        button.classList.add('product__option-value--active');
        fieldset.querySelector('[data-selected-value]').textContent = button.dataset.value;
        this.updateVariant();
      }

      selectThumbnail(button) {
        this.querySelectorAll('[data-thumbnail]').forEach((el) => el.classList.remove('product__thumbnail--active'));
        button.classList.add('product__thumbnail--active');
        const mainImage = this.querySelector('[data-main-media]');
        if (mainImage && button.dataset.fullSrc) mainImage.src = button.dataset.fullSrc;
      }

      getSelectedOptions() {
        return this.optionFieldsets
          .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
          .map((fieldset) => fieldset.querySelector('[data-selected-value]').textContent.trim());
      }

      updateVariant() {
        const selected = this.getSelectedOptions();
        const variant = this.variants.find((v) =>
          [v.option1, v.option2, v.option3].filter(Boolean).every((value, index) => value === selected[index])
        );
        if (!variant) return;

        const idInput = this.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;

        const priceEl = this.querySelector('[data-product-price]');
        if (priceEl) {
          const currentEl = priceEl.querySelector('.product__price-current');
          if (currentEl) currentEl.textContent = variant.price_formatted;

          const existingCompare = priceEl.querySelector('.product__compare-price');
          if (existingCompare) existingCompare.remove();

          if (variant.compare_at_price_formatted) {
            const compareEl = document.createElement('s');
            compareEl.className = 'product__compare-price';
            compareEl.textContent = variant.compare_at_price_formatted;
            priceEl.append(' ', compareEl);
          }
        }

        const addButton = this.querySelector('[data-add-to-cart]');
        const addLabel = this.querySelector('[data-add-to-cart-label]');
        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available ? addLabel.dataset.inStockLabel : addLabel.dataset.soldOutLabel;
        }

        if (variant.featured_image_src) {
          const mainImage = this.querySelector('[data-main-media]');
          if (mainImage) mainImage.src = variant.featured_image_src;
        }
      }
    }

    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();
})();
